<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QBAQgr/tc-custom/9783965373983.jpg?1703222303634" alt="This image is the cover for the book The Talleyrand Maxim, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Talleyrand Maxim, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: "It's old Mr. Bartle, sir, he whispered. He's in your room there -- dead! Dead? exclaimed Eldrick. Dead! Pratt shook his head again. He came up not so long after you'd gone, sir, he said. Everybody had gone but me -- I was just going. Wanted to see you about something I don't know what. He was very tottery when he came in -- complained of the stairs and the fog. I took him into your room, to sit down in the easy chair. And -- he died straight off. Just, concluded Pratt, just as if he was going quietly to sleep!"</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. S. Fletcher
      </h2>
      
      <p class="authorDescription body article">Joseph Smith Fletcher (7 February 1863 – 30 January 1935) was an English journalist and author. He wrote more than 230 books on a wide variety of subjects, both fiction and non-fiction, and was one of the most prolific English writers of detective fiction. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTBebook Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d3d43634